module.exports = __webpack_public_path__ + "img/submit_success_talent_exchange.17a5440c.png";